"use client";
import TripAuditInspection from "./components/TripAuditInspection";
import TripAuditSection from "./components/TripAuditSection";
import AccurateDamageDetection from "./icons/AccurateDamageDetection";
import CleanStructureWorkflow from "./icons/CleanStructureWorkflow";
import BeforeAfterComparison from "./icons/BeforeAfterComparison";
import AnywhereAccess from "./icons/AnywhereAccess";
import CostEffectivePlan from "./icons/CostEffectivePlan";
import FeatureCard from "./../../components/ui/FeatureCard";
import GlobeSection from "../ui/GlobeSection";
import FAQSection from "./components/FAQSection";
import AiSupportSection from "./components/AiSupportSection";
import { useTripAudit } from "../../contexts/TripAuditContext";
import HeroSection from "./components/HeroSection";
import VehicleHandoverLifecycle from "./components/VehicleHandoverLifecycle";
import InvoicePreCheckout from "./components/InvoicePreCheckout";
import InvoiceSetupForm from "./components/InvoiceSetupForm";
import { useEffect } from "react";
import { handleStart } from "./utils/helper";
const RootHomePage = () => {
  const { showInsurannceCover, showInvoicePreCheckout, showInvoiceForm } =
    useTripAudit();
  const KeyBenefits = [
    {
      icon: AccurateDamageDetection,
      title: "Improved Asset Protection",
      desc: "Maintains continuous visibility into vehicle condition across every drive.",
    },
    {
      icon: CleanStructureWorkflow,
      title: "Faster Claims Resolution",
      desc: "Speeds up decision-making with structured, evidence-backed records.",
    },
    {
      icon: BeforeAfterComparison,
      title: "Fewer Disputes",
      desc: "Provides clear, verifiable before-and-after records that eliminate ambiguity over damage responsibility.",
    },

    {
      icon: AnywhereAccess,
      title: "Instant Access to Drive Records",
      desc: "Retrieve any drive record instantly using a drive ID from any device, without searching through fragmented data.",
    },
    {
      icon: CostEffectivePlan,
      title: "Clear Charge Justification",
      desc: "Connects visual condition evidence directly to billing, making charges transparent and defensible.",
    },
  ];
  useEffect(() => {
    if (showInvoicePreCheckout || showInsurannceCover || showInvoiceForm) {
      const t = setTimeout(() => {
        document.getElementById("tripwise-section")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 50);
      return () => clearTimeout(t);
    }
  }, [showInvoicePreCheckout, showInsurannceCover, showInvoiceForm]);
  if (showInvoicePreCheckout)
    return (
      <div id="tripwise-section">
        <InvoicePreCheckout />
      </div>
    );
  if (showInsurannceCover)
    return (
      <div id="tripwise-section">
        {" "}
        <TripAuditInspection />
      </div>
    );
  if (showInvoiceForm)
    return (
      <div id="tripwise-section">
        {" "}
        <InvoiceSetupForm />
      </div>
    );
  return (
    <div className="">
      {/* <div className="bg-[#0A2540] pt-20 md:pt-40 pb-[60px]  w-full mx-auto text-center px-5">
        <TripAuditSection />
      </div> */}
      <div className=" h-[calc(100vh-70px)]">
        <HeroSection />
      </div>
      <div id="tripwise-section">
        <TripAuditInspection />
      </div>
      <div className="bg-white">
        <VehicleHandoverLifecycle />
      </div>
      {/* why ist matters */}
      {/* <div className="bg-[#FAFAFF]">
        <WhyTripAuditSection />
      </div> */}
      {/* common problem that trip audit solve */}
      {/* <CommonProblemSection /> */}
      {/* Key Benefits */}
      <section className="bg-white">
        <div className="max-w-[1200px] mx-auto w-full py-10 md:py-[60px] px-5">
          <h2 className="mb-10 lg:mb-[60px] text-center text-[#04082C] text-[28px] lg:text-[36px] font-bold">
            Key <span className="text-[#0336BC]">Benefits</span> at a Glance
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-[30px]">
            {KeyBenefits.slice(0, 3).map((data, index) => (
              <FeatureCard
                key={index}
                icon={<data.icon />}
                title2={data.title}
                description={data.desc}
                className="max-w-[380px] w-full"
              />
            ))}
            {/* Last 2 cards - centered on large screens */}
            <div className="lg:col-span-3 flex flex-col lg:flex-row justify-center gap-[30px] w-full">
              {KeyBenefits.slice(3).map((data, index) => (
                <FeatureCard
                  key={index + 3}
                  icon={<data.icon />}
                  title2={data.title}
                  description={data.desc}
                  className="max-w-[380px] w-full lg:w-[380px]"
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className="bg-white">
        <GlobeSection
          title="Generate your vehicle stamp today"
          description="Start documenting your vehicle condition in every handover"
          extraButton={
            <button
              onClick={handleStart}
              className="bg-[#2D65F2] px-5 py-3 rounded-md text-white font-openSans text-[16px] font-bold"
            >
              Order Now
            </button>
          }
        />
      </div>
      <div>
        <AiSupportSection />
      </div>
      <div className="bg-white">
        <FAQSection />
      </div>
    </div>
  );
};

export default RootHomePage;
